export default {"src":"/_next/static/media/MongoDB.adab8de8.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};